/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { AiOutlineSearch } from "react-icons/ai";

import {
  ActionIcon,
  Badge,
  Button,
  Input,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  CloseButton,
  TextInput,
  Anchor,
  Modal,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import {
  Eye,
  Plus,
  Search,
  SortAscending,
  SortDescending,
} from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import {
  deleteAgreementBulk,
  getSignedAgreementsCsv,
} from "../../utilities/apis/agreements";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
  formatIndianNumber,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementsList,
  getAgreementTypesApi,
  getAgreementsCsvDownload,
} from "../../utilities/apis/agreements";
import UserAvatarView from "../../components/UserAvatarView";
import DashboardNotifications from "../DashboardNotifications";
import { agreementStatusColors } from "../../utilities/enums";
import AgreementAnalytics from "../../components/AgreementAnalytics/AgreementAnalytics";
import colors, { themeColor } from "../../utilities/design";
import AgreementGraph from "./AgreementGraph";
import Styles from "./AgreementsListingPage.module.css";
import { INDIA_STATES_UNIONS } from "./AgreementForm2";
import HamburgerMenu from "../HamburgerMenuAgreements";
import HamburgerMenuAgreements from "../HamburgerMenuAgreements";
import AgreementAnalytics1 from "../../components/AgreementAnalytics/AgreementAnalytics1";
import AgreementGraph1 from "./AgreementGraph1";
import { getAgreementsInSignedList } from "../../utilities/apis/agreements";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";
import { getPartyNames } from "../../utilities/apis/parties";
import {
  IconArrowDownBar,
  IconArrowUpBar,
  IconSortAscendingNumbers,
} from "@tabler/icons-react";
import UniversalTable from "../../components/Common/UniversalTable";
import TablePagination from "../../components/Common/TablePagination";

const statusOptions = [
  {
    label: "Pending with Company",
    value: "Pending with Company",
  },
  {
    label: "TP",
    value: "TP",
  },
];

const estampOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

const AgreementsSigned = () => {
  const [businessunitList, setbusinessunitList] = useState([]);
  const [parties, setParties] = useState(["secondparty"]);
  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setbusinessunitList(data.businessunitList || []);
        } else {
          console.error("Invalid business unit response format:", response);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    const getPartyName = async () => {
      const response = await apiWrapWithErrorWithData(getPartyNames());
      if (response.success) {
        console.log("party de rha h bro: ", response);
        setParties(response.parties);
      }
    };
    getPartyName();
    fetchBusinessUnits();
  }, []);
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [transformedData, settransformedData] = useState([]);
  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      const temp = uniqueValues.map((item) => ({ label: item, value: item }));
      setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
    }
  };
  useEffect(() => {
    getAgreementTypes();
  }, []);
  useEffect(() => {
    if (businessunitList.length > 0) {
      settransformedData(
        businessunitList.map((unit) => ({
          value: unit.id + "",
          label: unit.name,
        }))
      );
    }
  }, [businessunitList]);

  const navigate = useNavigate();
  const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, "_blank"); // '_blank' specifically tells the browser to open in a new tab/window
  };

  const [year, setYear] = useState(2025);
  const [filters, setFilter] = useState({
    typeOfAgreement: null,
    mapBusinessunit: null,
    startDate: null,
    endDate: null,
    estamp: null,
    partyName: null,
    jobOrder: "",
    mapRegion: null,
  });
  const clearHandler = () => {
    setFilter({
      typeOfAgreement: null,
      mapBusinessunit: null,
      startDate: null,
      endDate: null,
      estamp: null,
      partyName: null,
      jobOrder: "",
    });
    setReload(!reload);
  };
  const [pageSize, setPageSize] = useState(10);
  const [reload, setReload] = useState(true);
  const [reviewAgreementpage, setReviewAgreementpage] = useState(1);
  const [sortByOptions, setSortByOptions] = useState({
    key: "createdAt",
    value: "desc",
  });
  let serialNumber = (reviewAgreementpage - 1) * pageSize + 1;
  const [configs, setConfigs] = useState({
    loading: loadingStates.LOADING,
    data: null,
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let filterOptions = {};
        if (filters.startDate && filters.endDate) {
          filterOptions["createdAt"] = {
            gte: formatISO(filters.startDate),
            lte: formatISO(filters.endDate),
          };
        } else if (filters.startDate || filters.endDate) {
          // Notify if only one date is selected
          showNotification({
            title: "Agreement notification",
            message: "Please select both start and end dates",
            color: "red",
          });
          return; // Exit if only one date is selected
        }
        if (
          filters.typeOfAgreement &&
          filters.estamp &&
          filters.mapBusinessunit
        ) {
          filterOptions = {
            ...filterOptions,
            typeOfAgreement: { equals: filters.typeOfAgreement },
            agreementType: {
              equals: filters.estamp === "Yes" ? "eStamp" : "normal",
            },
            mapBusinessunit: { equals: filters.mapBusinessunit },
          };
        } else {
          // Individual filter checks if any one of these fields is present
          if (filters.typeOfAgreement) {
            filterOptions["typeOfAgreement"] = {
              equals: filters.typeOfAgreement,
            };
          }
          if (filters.estamp) {
            filterOptions["agreementType"] = {
              equals: filters.estamp === "Yes" ? "eStamp" : "normal",
            };
          }
          if (filters.mapBusinessunit) {
            filterOptions["mapBusinessunit"] = {
              equals: filters.mapBusinessunit,
            };
          }
        }

        if (filters.partyName) {
          filterOptions["OR"] = [
            {
              secondParty: {
                path: "$.name",
                string_contains: filters.partyName,
                // mode: "insensitive",
              },
            },
            {
              secondParty: {
                path: "$.indi_name",
                string_contains: filters.partyName,
                // mode: "insensitive",
              },
            },
          ];
        }
        if (filters.jobOrder.length > 0) {
          filterOptions["jobOrder"] = { contains: filters.jobOrder };
        }
        const sortOption = { [sortByOptions.key]: sortByOptions.value };
        const response = await apiWrapWithErrorWithData(
          getAgreementsInSignedList({
            page: reviewAgreementpage,
            pageSize: pageSize,
            filterOptions: filterOptions,
            year: year,
            sortByOptions: sortOption,
          })
        );
        if (response) {
          setConfigs({
            loading: loadingStates.NO_ACTIVE_REQUEST,
            data: response,
          });
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    fetchData();
  }, [reviewAgreementpage, pageSize, year, reload, sortByOptions]);
  const handleCsvDownload = async () => {
    const response = await apiWrapWithErrorWithData(getSignedAgreementsCsv());
    if (response.success) {
      if (response?.agreements.length > 0) {
        const columnHeaders = Object.keys(response.agreements[0]);
        csvDownload({
          data: response.agreements,
          headers: columnHeaders,
          name: "signed agreements",
        });
      } else {
        showNotification({
          title: "Agreement csv download",
          message: "No agreement available",
          color: "red",
        });
      }
    }
  };

  
  // TABLE HEADERS CONFIGURATION
  const tableHeaders = [
    {
      label: "cin",
      render: (row) => (
        <Text size="sm" weight={600} color="#43A3B3">{`#${row.id}`}</Text>
      ),
    },
    { label: "bu", render: (row) => row.agreementData?.json?.location || "-" },
    {
      label: "type",
      render: (row) => row.agreementData?.json?.typeOfAgreement || "-",
    },
    {
      label: "job order",
      render: (row) => row?.jobOrder || "-",
    },
    {
      label: "second party",
      render: (row) => (
        <div>
          <Text size="sm" weight={500}>
            {row.agreementData?.json?.brandName}
          </Text>
          <Text
            size="xs"
            color="dimmed"
          >{`(${row.agreementData?.json?.secondParty?.name || "-"})`}</Text>
        </div>
      ),
    },
    { label: "value", render: (row) => formatIndianNumber(row.agreementValue) },
    {
      label: "start date",
      render: (row) => row.contractStartDate?.slice(0, 10) || "-",
    },
    {
      label: "end date",
      render: (row) => row.contractEndDate?.slice(0, 10) || "-",
    },
    {
      label: "actions",
      align: "right",
      render: (row) => (
        <div className="flex justify-end gap-2">
          {row.relationshipWith && (
            <ActionIcon
              variant="subtle"
              onClick={() => handlePlusClick(row.id)}
            >
              <Plus color="#1b6f8d" size={20} />
            </ActionIcon>
          )}
          <ActionIcon variant="subtle" onClick={() => onViewClick(row.id)}>
            <Eye color="#1b6f8d" size={20} />
          </ActionIcon>
        </div>
      ),
    },
  ];

  return (
    <>
      {configs.loading === loadingStates.NO_ACTIVE_REQUEST && (
        <>
          <div
            className="flex"
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <h1
              style={{
                fontSize: "22px",
                fontWeight: "600",
                letterSpacing: "1px",
                textTransform: "lowercase",
                fontFamily: "Lato",
                whiteSpace: "nowrap",
                paddingBottom: "13px",
                position: "relative",
                color: "black",
                // margin: "0 auto"
              }}
            >
              Signed
            </h1>

            <HamburgerMenuAgreements />
          </div>
          <div className="flex flex-row flex-wrap w-full">
            <AgreementAnalytics1
              filters={filters}
              setFilter={setFilter}
              configs={configs}
            />
          </div>
          <div className="flex">
            <AgreementGraph year={year} setYear={setYear} configs={configs} />
            <AgreementGraph1 configs={configs} />
          </div>

          <div className="flex flex-col">
            <div className="flex justify-between my-4">
              <Text>table view</Text>
            </div>
          </div>
        </>
      )}

      {configs.loading === loadingStates.LOADING && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}
      {configs.loading === loadingStates.NO_ACTIVE_REQUEST &&
        configs.data?.agreements && (
          <>
            <div className="flex w-full justify-between items-center">
              <div className="flex flex-col">
                <div className="flex flex-row-sm">
                  {/* <Text size="xs" className="mb-2" color="gray">
              Case sensitive search
            </Text> */}
                  <div className="flex items-center">
                    {/* <TextInput
                value={listing.searchString}
                onChange={(input) => {
                  const val = getValueForInput(input);
                  setListing((prevState) => ({
                    ...prevState,
                    searchString: val,
                  }));
                }}
                placeholder="Type to search..."
                icon={<Search size={14} />}
              /> */}

                    <Select
                      className="mx-2"
                      placeholder="estamp"
                      value={filters.estamp}
                      onChange={(val) => {
                        setFilter((prevState) => ({
                          ...prevState,
                          estamp: val,
                        }));
                      }}
                      data={estampOption}
                      style={{ minWidth: "228px" }}
                    />
                    <Select
                      className="mx-2"
                      placeholder="select contract type"
                      value={filters.typeOfAgreement}
                      onChange={(val) => {
                        setFilter((prevState) => ({
                          ...prevState,
                          typeOfAgreement: val,
                        }));
                      }}
                      data={agreementTypeOptions}
                      style={{ minWidth: "228px" }}
                    />
                    <Select
                      className="mx-2"
                      placeholder="select business unit"
                      value={filters.mapBusinessunit}
                      data={transformedData}
                      onChange={(value) => {
                        setFilter((prevState) => ({
                          ...prevState,
                          mapBusinessunit: value,
                        }));
                      }}
                      style={{ minWidth: "228px" }}
                    />
                    <TextInput
                      className="mx-2"
                      placeholder="type job order"
                      value={filters.jobOrder}
                      onChange={(e) =>
                        setFilter((preState) => ({
                          ...preState,
                          jobOrder: e.target.value,
                        }))
                      }
                      maw={400}
                      mx="auto"
                      style={{ minWidth: "228px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="flex w-full justify-between items-center">
              <div className="flex flex-col">
                <div className="flex flex-row">
                  <div className="flex items-center">
                    {/* <Select
                className="mx-2"
                placeholder="Select location"
                searchable={true}
                value={listing.location}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    location: val,
                  }));
                }}
                data={INDIA_STATES_UNIONS}
                style={{ minWidth: "228px" }}
              /> */}
                    <DatePicker
                      className="mx-2"
                      value={filters.startDate}
                      onChange={(val) =>
                        setFilter((preState) => ({
                          ...preState,
                          startDate: val,
                        }))
                      }
                      placeholder="created date (from)"
                      minDate={
                        new Date(new Date().setMonth(new Date().getMonth() - 3))
                      }
                      maw={400}
                      mx="auto"
                      style={{ minWidth: "228px" }}
                    />
                    <DatePicker
                      className="mx-2"
                      value={filters.endDate}
                      onChange={(val) =>
                        setFilter((preState) => ({ ...preState, endDate: val }))
                      }
                      placeholder="created date (to)"
                      minDate={filters.startDate}
                      disabled={filters.startDate ? false : true}
                      style={{ minWidth: "228px" }}
                    />
                    <Select
                      className="mx-2"
                      value={filters.partyName}
                      onChange={(value) => {
                        // const val = getValueForInput(input);
                        setFilter((prevState) => ({
                          ...prevState,
                          partyName: value,
                        }));
                      }}
                      placeholder="party name"
                      type="text"
                      searchable
                      data={parties}
                      style={{ minWidth: "228px" }}
                    />

                    <br />
                  </div>
                </div>
              </div>
            </div>
            <br />
          </>
        )}
      <Button
        className="mx-2"
        variant="outline"
        onClick={() => setReload(!reload)}
      >
        Search
      </Button>
      <Button className="mx-2" onClick={clearHandler}>
        Clear
      </Button>
      <div className="flex float-right">
        <div className="flex">
          <Select
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "created at", value: "createdAt" },
              { label: "end date", value: "dueDateOfContract" },
              { label: "type of agreement", value: "typeOfAgreement" },
              { label: "ain", value: "id" },
              { label: "agreement value", value: "agreementValue" },
            ]}
          />
          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <SortAscending size={32} />
            ) : (
              <SortDescending size={32} />
            )}
          </ActionIcon>
        </div>
        <Button
          className="mx-2 btn btn-success btn-lg "
          // disabled={exportButtonLoading}
          onClick={handleCsvDownload}
          // color={themeColor(colors.agreement)}
          style={{
            backgroundColor: "#1b6f8d",
          }}
        >
          Export
        </Button>
      </div>
      {configs.loading === loadingStates.NO_ACTIVE_REQUEST &&
        configs.data?.agreements && (
          <div>
            {/* UNIVERSAL TABLE IMPLEMENTATION */}
            <UniversalTable
              headers={tableHeaders}
              data={configs.data?.agreements}
              loading={configs.loading === loadingStates.LOADING}
            />

            {/* UNIVERSAL PAGINATION IMPLEMENTATION */}
            <TablePagination
              totalCount={configs.data?.agreementsCount}
              page={reviewAgreementpage}
              pageSize={pageSize}
              dataLength={configs.data?.agreements?.length}
              onPageChange={setReviewAgreementpage}
              onPageSizeChange={(s) => {
                setPageSize(s);
                setReviewAgreementpage(1);
              }}
            />
          </div>
        )}
    </>
  );
};

export default AgreementsSigned;
